var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-wrap" },
    [
      _vm.pwdMsg ? _c("pwd-notice") : _vm._e(),
      _c(
        "div",
        { staticClass: "login-top" },
        [
          _c("login-top"),
          _c("div", { staticClass: "content-part" }, [
            _c("div", { staticClass: "passWorldTip" }, [
              _c("div", { staticClass: "flex" }, [
                _c("img", {
                  staticClass: "tips-icon",
                  attrs: { src: require("@/assets/img/Rules.png") },
                }),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("login_password_hints")),
                  },
                }),
              ]),
              _c("div", { staticClass: "flex my-20" }, [
                _c("img", {
                  staticClass: "tips-icon",
                  attrs: { src: require("@/assets/img/Note.png") },
                }),
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("login_password_note")),
                  },
                }),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "ms-login" },
              [
                _c("div", { staticClass: "ms-title" }, [
                  _vm._v(_vm._s(_vm.$t("login_forget"))),
                ]),
                !_vm.forgotFlag
                  ? _c("p", { staticClass: "font-light" }, [
                      _vm._v(_vm._s(_vm.$t("login.forgot"))),
                    ])
                  : _c("p", { staticClass: "font-light" }, [
                      _vm._v(_vm._s(_vm.$t("login.changePassword"))),
                    ]),
                _vm.tabsShow && !_vm.forgotFlag
                  ? _c(
                      "el-tabs",
                      {
                        staticClass: "cust-tabs",
                        attrs: { type: "border-card" },
                        on: { "tab-click": _vm.handleTabClick },
                        model: {
                          value: _vm.param.verificationCodeType,
                          callback: function ($$v) {
                            _vm.$set(_vm.param, "verificationCodeType", $$v)
                          },
                          expression: "param.verificationCodeType",
                        },
                      },
                      _vm._l(_vm.tabs, function (tab) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: tab.code,
                            attrs: { name: tab.code, label: tab.name },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "tab-label",
                                attrs: { slot: "label" },
                                slot: "label",
                              },
                              [
                                _c("SvgIcon", {
                                  staticClass: "way-icon",
                                  attrs: {
                                    "icon-name": tab.icon,
                                    size: "18",
                                    "icon-color":
                                      _vm.param.verificationCodeType ===
                                      tab.code
                                        ? "#005eb8"
                                        : "rgb(38 47 63)",
                                  },
                                }),
                                _vm._v(" " + _vm._s(_vm.$t(tab.name))),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form",
                  {
                    ref: "login",
                    staticClass: "ms-content",
                    attrs: {
                      model: _vm.param,
                      rules: _vm.rules,
                      "label-width": "0px",
                    },
                  },
                  [
                    !_vm.forgotFlag
                      ? [
                          _vm.param.verificationCodeType === "EMAIL"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "item",
                                  staticStyle: { "margin-top": "0px" },
                                  attrs: { prop: "account" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "label label-disabled-active",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login_account")))]
                                  ),
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.param.account,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.param, "account", $$v)
                                      },
                                      expression: "param.account",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "el-form-item",
                                {
                                  staticClass: "item code-item mb_40",
                                  attrs: { prop: "code" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "label label-disabled-active",
                                    },
                                    [_vm._v(_vm._s(_vm.$t("login.phone")))]
                                  ),
                                  _c(
                                    "el-input",
                                    {
                                      ref: "phoneInput",
                                      staticClass: "phone-input right-btn-item",
                                      attrs: {
                                        disabled: "",
                                        placeholder: _vm.$t("login.phone"),
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.submitForm()
                                        },
                                      },
                                      model: {
                                        value: _vm.param.receiverNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.param,
                                            "receiverNumber",
                                            $$v
                                          )
                                        },
                                        expression: "param.receiverNumber",
                                      },
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "prepend" },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass:
                                                "forget-phone-prepend",
                                              class: {
                                                "zh-width":
                                                  _vm.$i18n.locale === "zh",
                                              },
                                              attrs: {
                                                slot: "prepend",
                                                disabled: "",
                                                placeholder: "请选择",
                                              },
                                              slot: "prepend",
                                              model: {
                                                value: _vm.regionPhone,
                                                callback: function ($$v) {
                                                  _vm.regionPhone = $$v
                                                },
                                                expression: "regionPhone",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("login.china"),
                                                  value: "+86",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label:
                                                    _vm.$t("login.HongKong"),
                                                  value: "+852",
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: _vm.$t("login.Macau"),
                                                  value: "+853",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item code-item",
                              attrs: { prop: "code" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: _vm.codeFocus
                                    ? "label label-active"
                                    : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.codeInput.focus()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("login_verification_Code"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  ref: "codeInput",
                                  class: [
                                    "right-btn-item",
                                    _vm.codeBtn ? "code_disabled" : "",
                                  ],
                                  on: {
                                    focus: function ($event) {
                                      _vm.codeFocus = true
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submitForm()
                                    },
                                  },
                                  model: {
                                    value: _vm.param.verificationCode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.param,
                                        "verificationCode",
                                        $$v
                                      )
                                    },
                                    expression: "param.verificationCode",
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "append" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "login-btn",
                                          attrs: {
                                            disabled: _vm.codeBtn,
                                            loading: _vm.codeLoading,
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getCode()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getCodeSecond > 0
                                                  ? `${_vm.getCodeSecond} s`
                                                  : _vm.$t("login_btn_getCode")
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.forgotFlag
                      ? [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item",
                              staticStyle: { "margin-top": "0px" },
                              attrs: { prop: "account" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "label label-disabled-active" },
                                [_vm._v(_vm._s(_vm.$t("login_account")))]
                              ),
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.param.account,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.param, "account", $$v)
                                  },
                                  expression: "param.account",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item",
                              staticStyle: { "margin-bottom": "0.27rem" },
                              attrs: { prop: "newPassword" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: _vm.newPwdFocus
                                    ? "label label-active"
                                    : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.newPassword.focus()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("login_new_passWorld")))]
                              ),
                              _c(
                                "el-input",
                                {
                                  ref: "newPassword",
                                  attrs: {
                                    "show-password": "",
                                    onpaste: "return false",
                                  },
                                  on: {
                                    blur: _vm.newPasswordChange,
                                    focus: function ($event) {
                                      _vm.newPwdFocus = true
                                    },
                                  },
                                  model: {
                                    value: _vm.param.newPassword,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.param, "newPassword", $$v)
                                    },
                                    expression: "param.newPassword",
                                  },
                                },
                                [_c("template", { slot: "append" })],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "item",
                              staticStyle: { "margin-bottom": "0.27rem" },
                              attrs: { prop: "reNewPassword" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: _vm.reNewPwdFocus
                                    ? "label label-active"
                                    : "label",
                                  on: {
                                    click: () => {
                                      _vm.$refs.reNewPassword.focus()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("login_renew_passWorld"))
                                  ),
                                ]
                              ),
                              _c(
                                "el-input",
                                {
                                  ref: "reNewPassword",
                                  attrs: {
                                    "show-password": "",
                                    onpaste: "return false",
                                  },
                                  on: {
                                    focus: function ($event) {
                                      _vm.reNewPwdFocus = true
                                    },
                                  },
                                  nativeOn: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.submitForm()
                                    },
                                  },
                                  model: {
                                    value: _vm.param.reNewPassword,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.param, "reNewPassword", $$v)
                                    },
                                    expression: "param.reNewPassword",
                                  },
                                },
                                [_c("template", { slot: "append" })],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "footer-login" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "login-btn login-item",
                            attrs: {
                              loading: _vm.loginLoading,
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("login_btn_confirm")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("v-bottom"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }